import { PipeTransform } from '@angular/core';
var FilterPipe = /** @class */ (function () {
    function FilterPipe() {
    }
    FilterPipe.prototype.transform = function (items, key, val) {
        if (!items || !key || !val) {
            return items;
        }
        // filter items array, items which match and return true will be kept, false will be filtered out
        return items.filter(function (item) { return item[key] === val; });
    };
    return FilterPipe;
}());
export { FilterPipe };
